<template>
  <ValidationProvider v-slot="{ errors }" :name="`'${label}'`" :rules="rules" :vid="vid">
    <v-combobox
        item-value="key"
        item-text="value"
        :items="filterItems"
        :value="current"
        :error-messages="errors"
        :label="label"
        :readonly="readonly"
        :clearable="clearable && !readonly"
        :prepend-icon="prependIcon"
        :search-input.sync="search"
        return-object
        eager
        :dense="dense"
        @change="change"
        @contextmenu.prevent>
      <template v-slot:prepend-inner>
        <v-icon
            v-if="required"
            small
            left
            :color="requiredColor">
          *
        </v-icon>
      </template>
    </v-combobox>
  </ValidationProvider>
</template>

<script>
  export default {
    props: {
      value: {
        type: [String, Number],
        default: null
      },
      rules: [String, Object],
      prependIcon: {
        type: String,
        default: ''
      },
      items: {
        type: Array,
        require: true,
        default: () => {
          return []
        }
      },
      requiredColor: {
        type: String,
        default: 'requiredfield'
      },
      label: {
        type: String,
        default: ''
      },
      readonly: {
        type: Boolean,
        default: false
      },
      clearable: {
        type: Boolean,
        default: false
      },
      dense: {
        type: Boolean,
        default: false
      },
      vid: {
        type: String,
        default: null
      }
    },
    data () {
      return {
        isLoading: false,
        search: ''
      }
    },
    computed: {
      required () {
        if (!this.rules) {
          return false
        }
        return (this.rules.hasOwnProperty('required') && this.rules.required) ||
          (!this.rules.hasOwnProperty('required') &&
            !!this.rules.length &&
            this.rules.includes('required'))
      },
      current () {
        const vm = this
        return vm.items.find(u => u.key === vm.value)
      },
      filterItems () {
        let items = this.items
        if (this.search && (!this.current || this.search !== this.current.value)) {
          items = items.filter(p => p.value.includes(this.search))
        }
        if (this.current && this.current.key) {
          items = items.filter(p => this.current.key !== p.key)
        }
        return items
      }
    },
    methods: {
      change: function (item) {
        this.$emit('input', item ? item.key : null)
      }
    }
  }
</script>
